import i18n from "i18next";

import { EntityAttribute } from "shared/api/api";
import { GENERIC_FILTER_WITHOUT_SELECT } from "shared/filterDefinitions";

import { UseSchema } from "./types";
import {
  getAttributeMap,
  getDisplayLabelFunction,
  getFilterFunction,
  getSchemaEntryFunction,
  getSchemaForAccessorFunction,
  getSchemaFromAttributes,
} from "./utils/schema-utils";

const useGeneralDescriptionSchema = (filtering = false): UseSchema => {
  const t = i18n.t;
  const attributes: EntityAttribute[] = [
    {
      displayName: t("common:description"),
      columnName: t("common:description"),
      dataExplorerColumnName: t("common:description"),
      ID: "description",
      description: "",
      type: "string",
      displayWideColumn: false,
      hideInTable: false,
      hideFilter: false,
      nullable: true,
      filtering,
      attributeGrouping: false,
      grouping: false,
      inJSONBody: true,
      sorting: false,
      values: false,
      filteringConfig: {
        negativeNumbers: false,
        empty: filtering,
        startsWith: filtering,
        contains: filtering,
        decimalNumbers: false,
        lowCardinality: false,
        minMax: false,
      },
      byVehicleAgeBirthday: false,
      byVehicleAgeExposure: false,
      byVehicleAgeExposureBuckets: [],
      columnWidth: null,
    },
  ];

  const attributeMap = getAttributeMap(attributes);

  const getDisplayLabel = getDisplayLabelFunction(attributeMap);

  const getFilter = getFilterFunction(
    GENERIC_FILTER_WITHOUT_SELECT,
    attributeMap
  );

  const getSchemaEntry = getSchemaEntryFunction(getFilter, attributeMap);

  const schema = getSchemaFromAttributes(attributes, getSchemaEntry);

  const getSchemaForAccessor = getSchemaForAccessorFunction(schema);

  return {
    schema,
    getDisplayLabel,
    attributeMap,
    attributes,
    getSchemaEntry,
    attributeAccessors: schema.map(
      ({ accessor, filter }) => filter?.fieldName || accessor
    ),
    getSchemaForAccessor,
  };
};
export default useGeneralDescriptionSchema;
